<script setup lang="ts">
interface Props {
    title?: string
    content?: string | number | null
}

const props = defineProps<Props>()
</script>
<template>
    <div class="flex flex-col items-start">
        <span class="text-xs font-semibold text-primary-500 dark:text-primary-300">
            <slot name="title">{{ props.title }}</slot>
        </span>
        <span class="text-sm text-primary-500 dark:text-primary-100 w-full space-y-1.5">
            <slot>{{ props.content ?? '-' }}</slot>
        </span>
    </div>
</template>
